import { Link } from "react-router-dom";
import AdminLayout from "../../Admin/AdminLayout";

const ResetPassword = () => {
  return (
    <AdminLayout>
      <div className="login_wepper">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 p-0">
              <div className="login_inner_wepper">
                <h2>Reset Password</h2>
                <form action="">
                  <div className="row from_wepper">
                    <div className="col-lg-12">
                      <div className="form-group ">
                        <label htmlFor="fname">Password</label>
                        <div className="add_user_input">
                          <input
                            type="text"
                            name="fname"
                            className="form-control"
                            placeholder="********"
                            fdprocessedid="bftiel"
                          />
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_847_322)">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M8.536 6C9.228 4.80467 10.5207 4 12 4C14.2073 4 16 5.79267 16 8C16 10.2073 14.2073 12 12 12C10.5207 12 9.228 11.1953 8.536 10H6L4.996 8.998L4 10L3.01333 8.998L2 10L0 7.97867L1.68667 6H8.536V6ZM13.6667 7C14.2187 7 14.6667 7.448 14.6667 8C14.6667 8.552 14.2187 9 13.6667 9C13.1147 9 12.6667 8.552 12.6667 8C12.6667 7.448 13.1147 7 13.6667 7Z"
                                fill="#6F757E"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_847_322">
                                <rect width="16" height="16" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group ">
                        <label htmlFor="fname">Password</label>
                        <div className="add_user_input">
                          <input
                            type="text"
                            name="fname"
                            className="form-control"
                            placeholder="Confirm password"
                            fdprocessedid="bftiel"
                          />
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_847_322)">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M8.536 6C9.228 4.80467 10.5207 4 12 4C14.2073 4 16 5.79267 16 8C16 10.2073 14.2073 12 12 12C10.5207 12 9.228 11.1953 8.536 10H6L4.996 8.998L4 10L3.01333 8.998L2 10L0 7.97867L1.68667 6H8.536V6ZM13.6667 7C14.2187 7 14.6667 7.448 14.6667 8C14.6667 8.552 14.2187 9 13.6667 9C13.1147 9 12.6667 8.552 12.6667 8C12.6667 7.448 13.1147 7 13.6667 7Z"
                                fill="#6F757E"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_847_322">
                                <rect width="16" height="16" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-12 submit_btn">
                      <input
                        type="submit"
                        id=""
                        name=""
                        value="Reset Password"
                      />
                    </div>
                    <div className="accout_setp">
                      <p>
                        Back to <Link to="/">Login</Link>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-lg-6 p-0">
              <div className="login_img_data">
                <img src="images/right-login.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default ResetPassword;
